import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	MyPlannDrawer,
	type MyPlannDrawerProps,
} from "web_myplann/Shared/Components/MyPlannDrawer";
import {
	ActionsDrawerRow,
	type DrawerAction,
} from "web_myplann/Shared/Components/Redesign/ActionsDrawerRow";

type Props = Pick<MyPlannDrawerProps, "open" | "title" | "concealed"> & {
	actions: DrawerAction[];
	onClose: () => void;
};

export const ActionsDrawerRedesign: FC<Props> = ({
	open,
	title,
	concealed,
	actions,
	onClose,
}) => (
	<MyPlannDrawer
		open={open}
		onClose={onClose}
		title={title}
		concealed={concealed}
	>
		<Stack pb={1.6}>
			{actions.map((action, index) => (
				<ActionsDrawerRow
					key={action.key}
					action={action}
					isLast={index === actions.length - 1}
				/>
			))}
		</Stack>
	</MyPlannDrawer>
);
